<template>
  <div class="loginCode">
    <div class="return" @click="goBack">
      <svg t="1652074432031" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1496" width="200" height="200"><path d="M729.6 931.2l-416-425.6 416-416c9.6-9.6 9.6-25.6 0-35.2-9.6-9.6-25.6-9.6-35.2 0l-432 435.2c-9.6 9.6-9.6 25.6 0 35.2l432 441.6c9.6 9.6 25.6 9.6 35.2 0C739.2 956.8 739.2 940.8 729.6 931.2z" p-id="1497" fill="#666666" data-spm-anchor-id="a313x.7781069.0.i2" class=""></path></svg>
       返回
    </div>
    <wxlogin 
      :appid="appid" 
      scope="snsapi_login" 
      :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlewogICAgZGlzcGxheTogbm9uZSA7IAp9IAoud3JwX2NvZGV7CiAgbWFyZ2luLXRvcDogMzVweDsKfQoud3JwX2NvZGUgLnFyY29kZXsKICBib3JkZXI6IG5vbmU7CiAgd2lkdGg6IDIwOHB4OwogIGhlaWdodDogMjA4cHg7Cn0KCi5pbXBvd2VyQm94IC5zdGF0dXMgcCB7CiAgICBmb250LXNpemU6IDE4cHg7CiAgICBjb2xvcjogIzY2NjY2NjsKfQojd3hfYWZ0ZXJfc2NhbnsKICBwYWRkaW5nLWxlZnQ6IDIwcHg7Cn0KI3d4X2FmdGVyX3NjYW4gLnN0YXR1c190eHQgaDR7CiAgY29sb3I6ICM2NjY2NjY7CiAgZm9udC1zaXplOiAxOHB4Owp9CiN3eF9hZnRlcl9zY2FuIC5zdGF0dXNfdHh0IHB7CiAgZm9udC1zaXplOiAxNHB4Owp9CiN3eF9hZnRlcl9jYW5jZWwgLnN0YXR1c190eHQgaDR7CiAgY29sb3I6ICM2NjY2NjY7CiAgZm9udC1zaXplOiAxOHB4Owp9CiN3eF9hZnRlcl9jYW5jZWwgLnN0YXR1c190eHQgcHsKICBmb250LXNpemU6IDE0cHg7Cn0='"
      :redirect_uri="redirect_uri" ></wxlogin>
  </div>
</template>
<script>
import wxlogin from './vue-wxlogin';
    
export default {
  name: 'loginCode',
  data () {
    return {
      appid: 'wxddd50d200e27d8d1',
      redirect_uri: '',
      host: ''
    }
  },
  components: {
      wxlogin
    },
  methods: {
    goBack(){
      this.$emit('goBack')
    }
  },
  mounted () {
    const host = document.domain
    // 集美的单独处理
    if (this.$url === 'https://guanli.xmjmedu.com') {
      this.appid = 'wx61f1f237e095e1f1'
      this.redirect_uri = 'https://guanli.xmjmedu.com/wxlogin?type=0-'+host
    } else if (this.$url === 'https://zhxy.xmxdzx.com') {
      // 新店中学
      this.appid = 'wxa9a77fa123f992c8'
      this.redirect_uri = `${this.$url}/wxlogin?type=0-${host}`
    } else if (this.$url === 'https://itayz.xmedu.cn') {
      // 同中
      this.appid = 'wx10d213ced54ba755'
      this.redirect_uri = `${this.$url}/wxlogin?type=0-${host}`
    } else {
      this.redirect_uri = 'https://user.topeti.com/wxlogin?type=0-'+host
    }
  }
}
</script>

<style scoped lang="scss">
.loginCode{
  height: 350px;
  position: relative;
  
  .loginCode-info{
    position: absolute;
    top: 270px;
    left: 100px;
    font-size: 18px;
    color: #666666;
  }
}
.return{
  position: absolute;
  top: 0px;
  left: 0px;
  color: #666666;
  font-size: 16px;
  cursor: pointer;
  svg{
    width: 18px;
    height: 28px;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }
}
</style>
